(ns teamoesterreich.actions.page-flow
  (:require
    [clojure.string :as str]
    [reagent.core :as r]
    [teamoesterreich.actions.auth :as a-auth]
    [teamoesterreich.store :as store]
    [teamoesterreich.util.log :as log])
  )


(def BACK_FLOW {

                :landing                                :landing

                :neighbor                               :landing

                :wanaPrepare                            :landing
                :wanaHelp                               :landing
                :wanaBeWarned                           :landing
                :wanaNeighbourHelp                      :landing


                :wanaHelpOnline                         :wanaHelp
                :wanaHelpOnline-profile-devices         :wanaHelpOnline
                :wanaHelpOnline-profile-personal        :wanaHelpOnline

                :wanaHelpLebensretter                   :wanaHelp
                :wanaHelpLebensretter-profile-documents :LAST
                :wanaHelpLebensretter-profile-personal  :LAST

                :wanaHelpNoKat                          :wanaHelp
                :wanaHelpNoKat-profile-wanado           :wanaHelpNoKat
                :wanaHelpNoKat-profile-qualifications   :wanaHelpNoKat
                :wanaHelpNoKat-profile-personal         :wanaHelpNoKat

                :wanaHelpKat                            :wanaHelp
                :wanaHelpKat-profile-wanado             :wanaHelpKat
                :wanaHelpKat-profile-qualifications     :wanaHelpKat
                :wanaHelpKat-profile-personal           :wanaHelpKat

                :wanaHelpTafel                          :wanaHelp
                :wanaHelpTafel-profile-wanado           :wanaHelpTafel
                :wanaHelpTafel-profile-personal         :wanaHelpTafel

                :wanaHelpNeighbor                       :wanaHelp
                :wanaHelpNeighbor-profile-personal      :wanaHelpNeighbor
                :wanaHelpNeighbor-profile-wanado        :wanaHelpNeighbor

                :prevent-overview                       :landing
                :prevent-help                           :prevent-overview
                :prevent-locationView                   :prevent-overview
                :prevent-locationForm                   :prevent-locationView
                :prevent-locationCreate                 :prevent-overview


                :warning-overview                       :landing
                :warning-help                           :warning-overview
                :warning-location                       :warning-overview
                :warning-locationView                   :warning-location
                :warning-locationForm                   :warning-locationView
                :warning-locationCreate                 :warning-overview


                :questionnaire-intro                    :prevent-overview
                :questionnaire-help                     :questionnaire-intro
                :questionnaire-question                 :questionnaire-intro
                :questionnaire-info                     :questionnaire-question
                :questionnaire-summary                  :prevent-overview

                :questionnaire-location-intro           :prevent-overview
                :questionnaire-location-info            :questionnaire-location-intro
                :questionnaire-location-question        :questionnaire-location-intro
                :questionnaire-location-summary         :prevent-overview



                :profile                                :landing
                :profile-personal                       :profile
                :profile-qualifications                 :profile
                :profile-notifications                  :profile
                :profile-documents                      :LAST
                :profile-wanado                         :profile
                :profile-events                         :profile
                :profile-devices                        :profile
                :profile-setup                          :profile
                :profile-personal-prevent-overview      :profile-personal
                :profile-personal-location-list         :profile-personal
                :profile-personal-location-create       :profile-personal-location-list
                :profile-personal-location-form         :profile-personal-location-list

                :news-list                              :landing
                :news-detail                            :news-list

                :impressum                              :LAST
                :dsgvo                                  :LAST

                })

(defn load-path []
  (let [path js/location.pathname]
    (log/out "Loading URL" path)
    (cond
      (str/starts-with? path "/oauth/")
      (-> (a-auth/handle-oauth-url)
          (.catch (fn [e]
                    (js/console.error "LOAD ERROR" e)
                    (js/history.replaceState nil nil "/")
                    (swap! store/app-state assoc :site :landing :load-error true)
                    nil))
          (.then (fn [_]
                   (let [mode (keyword (or (not-empty (get (str/split path #"/") 3)) "user"))]
                        (println "MODEHELP:" (str/split path #"/"))
                     (case mode
                       :user (js/history.replaceState nil nil "/")
                       :event (js/history.replaceState nil nil "/event")
                       :lebensretter (js/history.replaceState nil nil "/lebensretter"))
                     mode))))

      (= "/login" path)
      (a-auth/open-login)

      (= "/landing" path)
      (do
        (js/history.replaceState nil nil "/")
        (swap! store/app-state assoc :site :landing)
        (js/Promise. (fn [resolve _] (resolve :user))))

      (= "/" path)
      (do
        (swap! store/app-state assoc :site :landing)
        (js/Promise. (fn [resolve _] (resolve :user))))

      (re-matches #"^/lebensretter.*" path)
      (do
        (swap! store/app-state assoc :site :lebensretter)
        (js/Promise. (fn [resolve _] (resolve :lebensretter))))

      (re-matches #"^/event" path)
      (do
        (swap! store/app-state assoc :site :event)
        (js/Promise. (fn [resolve _] (resolve :event))))

      (re-matches #"^/[^/]+" path)
      (do
        (swap! store/app-state assoc :site (keyword (subs path 1)))
        (js/Promise. (fn [resolve _] (resolve :user))))

      :else
      (do
        (js/history.replaceState nil nil "/")
        (swap! store/app-state assoc :site :landing)
        (js/Promise. (fn [resolve _] (resolve :user))))
      )))

(defn set-path [new-page last-page]
  (log/out "Switching to" new-page "with back" last-page)
  (if (= new-page :login)
    (a-auth/open-login)
    (do
      (if (= new-page :landing)
        (js/history.pushState nil nil "/")
        (js/history.pushState nil nil (name new-page)))
      (swap! store/app-state assoc
             :site new-page
             :last last-page))))




(defn set-no-back-page [new-page]
  (.scrollTo js/window 0 0)
  (set-path new-page nil)
  )


(defn get-page []
  (let [!site (r/cursor store/app-state [:site])]
    @!site))

(defn get-last-page []
  (let [!site (r/cursor store/app-state [:last])]
    @!site))

(defn set-page [new-page & [back-button-page]]
  (let [new-page (name new-page)
        new-page (keyword (if (not= "" new-page) new-page "landing"))
        last-page (or back-button-page (get-page))]
    (println "Set page: --->> " new-page " <-" last-page " (" (get-page))
    (.scrollTo js/window 0 0)

    (set-path new-page last-page)))

(defn set-page-back []
  (let [actual-page (get-page)
        last-page (get-last-page)
        flow-back-page (get BACK_FLOW actual-page)
        flow-back-page (if (= flow-back-page :LAST) last-page flow-back-page)
        flow-back-page (or flow-back-page last-page)
        ]
    (.scrollTo js/window 0 0)
    (println "Set page back: --->> " flow-back-page " last" last-page " (" actual-page " FlowBack: " (get BACK_FLOW actual-page))

    (set-path flow-back-page nil)
    ))


